import React from 'react';
import { Card, CardActions, CardContent, Grid } from '@mui/material';
import { getAccessStatus } from '.';
import { CerebroLabel, CerebroText, CerebroTextButton } from '../../../shared/components';
import { CompanyContactDataRoom, CurrentUser, DataRoom } from '../../../shared/models';
import { DateUtils } from '../../../shared/utils';
import { BorrowerParticipantActionButton } from './BorrowerParticipantsActionButton';

interface BorrowerListProps {
	currentUser: CurrentUser;
	hasFullAccess: boolean;
	dataRoom: DataRoom;
	borrowers: CompanyContactDataRoom[];
	onEdit: (record: CompanyContactDataRoom) => void;
	onSendAccountInfo: (record: CompanyContactDataRoom) => void;
}

export const BorrowerList: React.FC<BorrowerListProps> = ({
	currentUser,
	dataRoom,
	borrowers,
	onEdit,
	onSendAccountInfo,
}) => {
	return (
		<Grid container spacing={2} alignItems="stretch">
			<Grid item xs={12}>
				{borrowers.map(contact => (
					<Card
						elevation={3}
						key={contact.guid}
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							flexDirection: 'column',
							height: '200px',
							marginBottom: 2,
						}}
					>
						<CardContent sx={{ paddingBottom: '0 !important' }}>
							<Grid container sx={{ marginBottom: 2 }}>
								<Grid item xs={8}>
									<CerebroText variant="large" component="span" sx={{ fontWeight: 'bold' }}>
										{contact.firstName} {contact.lastName}
									</CerebroText>
								</Grid>
								<Grid item xs={4} sx={{ textAlign: 'right' }}>
									<CerebroLabel sx={{ fontWeight: 'bold' }}>{getAccessStatus(contact)}</CerebroLabel>
								</Grid>
							</Grid>
							<CerebroText gutterBottom sx={{ marginTop: 3 }}>
								{contact.emailAddress}
							</CerebroText>
						</CardContent>
						<CardActions
							sx={theme => ({
								alignItems: 'flex-end',
								backgroundColor: theme.palette.gray.background,
								borderTop: `1px solid ${theme.palette.divider}`,
								justifyContent: 'space-between',
							})}
						>
							<BorrowerParticipantActionButton
								isEmployee={currentUser.isEmployeeUser}
								isCompanyUser={currentUser.isCompanyUser}
								isBanker={currentUser.isBankUser}
								dataRoom={dataRoom}
								contact={contact}
								edit={onEdit}
								sendAccountInfo={onSendAccountInfo}
							/>

							<CerebroText
								variant="small"
								style={{
									textAlign: 'right',
									paddingBottom: '6px',
									paddingRight: '6px',
								}}
							>
								{contact.lastAccessedOn
									? `Last accessed on ${DateUtils.FormatStringAsShortDate(
											contact.lastAccessedOn.toString()
									  )}`
									: 'Never Accessed'}
							</CerebroText>
						</CardActions>
					</Card>
				))}
			</Grid>
		</Grid>
	);
};
